export const PULL_ADVERTISING_CAMPAIGNS = 'PULL_ADVERTISING_CAMPAIGNS';
export const SET_ADVERTISING_CAMPAIGNS = 'SET_ADVERTISING_CAMPAIGNS';
export const PULL_USER_CUSTOM_AD_CAMPAIGNS = 'PULL_USER_CUSTOM_AD_CAMPAIGNS';
export const UPLOAD_USER_CUSTOM_AD_CAMPAIGNS = 'UPLOAD_USER_CUSTOM_AD_CAMPAIGNS';
export const SET_USER_CUSTOM_AD_CAMPAIGNS = 'SET_USER_CUSTOM_AD_CAMPAIGNS';
export const DELETE_USER_CUSTOM_AD_CAMPAIGN = 'DELETE_USER_CUSTOM_AD_CAMPAIGN';
export const PULL_ADVERTISING_CAMPAIGN_DETAILS = 'PULL_ADVERTISING_CAMPAIGN_DETAILS';
export const SET_ADVERTISING_CAMPAIGN_DETAILS = 'SET_ADVERTISING_CAMPAIGN_DETAILS';
export const UPDATE_ADVERTISING_CAMPAIGN_DETAILS = 'UPDATE_ADVERTISING_CAMPAIGN_DETAILS';
export const SET_ADVERTISING_FETCHING = 'SET_ADVERTISING_FETCHING';
export const PULL_ANALYTICS_CHART_DATA = 'PULL_ANALYTICS_CHART_DATA';
export const SET_ANALYTICS_CHART_DATA = 'SET_ANALYTICS_CHART_DATA';
export const PULL_ASIN_KEYWORD_CHART_DATA = 'PULL_ASIN_KEYWORD_CHART_DATA';
export const SET_ASIN_KEYWORD_CHART_DATA = 'SET_ASIN_KEYWORD_CHART_DATA';
export const UPLOAD_ASIN_KEYWORD_CHART_DATA = 'UPLOAD_ASIN_KEYWORD_CHART_DATA';
export const PULL_CUSTOM_CAMPAIGNS_DETAILED_DATA = 'PULL_CUSTOM_CAMPAIGNS_DETAILED_DATA';
export const PULL_CUSTOM_CAMPAIGN_PRODUCTS_DETAILED_DATA =
  'PULL_CUSTOM_CAMPAIGN_PRODUCTS_DETAILED_DATA';
export const SET_CUSTOM_CAMPAIGN_PRODUCTS_DETAILED_DATA =
  'SET_CUSTOM_CAMPAIGN_PRODUCTS_DETAILED_DATA';
export const SET_CUSTOM_CAMPAIGNS_DETAILED_DATA = 'SET_CUSTOM_CAMPAIGNS_DETAILED_DATA';
export const SET_CUSTOM_CAMPAIGNS_PRODUCTS_DETAILED_DATA =
  'SET_CUSTOM_CAMPAIGNS_PRODUCTS_DETAILED_DATA';
export const SET_CHART_WINDOW_SIZE = 'SET_CHART_WINDOW_SIZE';
export const SET_CHART_DECAY_THRESHOLD = 'SET_CHART_DECAY_THRESHOLD';
export const SET_SELECTED_METRICS = 'SET_SELECTED_METRICS';
export const SET_SELECTED_SECONDARY_METRICS = 'SET_SELECTED_SECONDARY_METRICS';
export const SET_SELECTED_THIRD_METRICS = 'SET_SELECTED_THIRD_METRICS';
export const SET_IS_PARENT_VIEW = 'SET_IS_PARENT_VIEW';
export const SET_CAMPAIGN_KEYWORD_SELECTIONS = 'SET_CAMPAIGN_KEYWORD_SELECTIONS';

export const pullAdvertisingCampaignsAction = payload => ({
  type: PULL_ADVERTISING_CAMPAIGNS,
  payload
});
export const setAdvertisingCampaignsAction = payload => ({
  type: SET_ADVERTISING_CAMPAIGNS,
  payload
});

export const pullAdvertisingCampaignDetailsAction = payload => ({
  type: PULL_ADVERTISING_CAMPAIGN_DETAILS,
  payload
});

export const setAdvertisingCampaignDetailsAction = payload => ({
  type: SET_ADVERTISING_CAMPAIGN_DETAILS,
  payload
});

export const updateAdvertisingCampaignDetailsAction = payload => ({
  type: UPDATE_ADVERTISING_CAMPAIGN_DETAILS,
  payload
});

export const setAdvertisingFetchingAction = payload => ({
  type: SET_ADVERTISING_FETCHING,
  payload
});

export const pullUserCustomAdCampaignsAction = payload => ({
  type: PULL_USER_CUSTOM_AD_CAMPAIGNS,
  payload
});

export const uploadUserCustomAdCampaignsAction = payload => ({
  type: UPLOAD_USER_CUSTOM_AD_CAMPAIGNS,
  payload
});

export const setUserCustomAdCampaignsAction = payload => ({
  type: SET_USER_CUSTOM_AD_CAMPAIGNS,
  payload
});

export const deleteUserCustomAdCampaignAction = payload => ({
  type: DELETE_USER_CUSTOM_AD_CAMPAIGN,
  payload
});

export const pullAnalyticsChartDataAction = payload => ({
  type: PULL_ANALYTICS_CHART_DATA,
  payload
});

export const setAnalyticsChartDataAction = payload => ({
  type: SET_ANALYTICS_CHART_DATA,
  payload
});

export const pullAsinKeywordChartDataAction = payload => ({
  type: PULL_ASIN_KEYWORD_CHART_DATA,
  payload
});

export const setAsinKeywordChartDataAction = payload => ({
  type: SET_ASIN_KEYWORD_CHART_DATA,
  payload
});

export const uploadAsinKeywordChartDataAction = payload => ({
  type: UPLOAD_ASIN_KEYWORD_CHART_DATA,
  payload
});

export const pullCustomCampaignsDetailedDataAction = payload => ({
  type: PULL_CUSTOM_CAMPAIGNS_DETAILED_DATA,
  payload
});

export const setCustomCampaignsDetailedDataAction = payload => ({
  type: SET_CUSTOM_CAMPAIGNS_DETAILED_DATA,
  payload
});

export const setCustomCampaignsProductsDetailedDataAction = payload => ({
  type: SET_CUSTOM_CAMPAIGNS_PRODUCTS_DETAILED_DATA,
  payload
});

export const setChartWindowSizeAction = payload => ({
  type: SET_CHART_WINDOW_SIZE,
  payload
});

export const setChartDecayThresholdAction = payload => ({
  type: SET_CHART_DECAY_THRESHOLD,
  payload
});

export const setSelectedMetricsAction = payload => ({
  type: SET_SELECTED_METRICS,
  payload
});

export const setSelectedSecondaryMetricsAction = payload => ({
  type: SET_SELECTED_SECONDARY_METRICS,
  payload
});

export const setSelectedThirdMetricsAction = payload => ({
  type: SET_SELECTED_THIRD_METRICS,
  payload
});

export const setIsParentViewAction = payload => ({
  type: SET_IS_PARENT_VIEW,
  payload
});

export const setCampaignKeywordSelectionsAction = payload => ({
  type: SET_CAMPAIGN_KEYWORD_SELECTIONS,
  payload
});

export const pullCustomCampaignProductsDetailedDataAction = payload => ({
  type: PULL_CUSTOM_CAMPAIGN_PRODUCTS_DETAILED_DATA,
  payload
});

export const setCustomCampaignProductsDetailedDataAction = payload => ({
  type: SET_CUSTOM_CAMPAIGN_PRODUCTS_DETAILED_DATA,
  payload
});
